import type { GuideStepConfig } from "./ProductGuideModal";
import {
  faRobot,
  faImages,
  faWandMagicSparkles,
  faShareSquare,
  faPenFancy,
  faCalendarAlt,
  faHistory,
  faThumbsUp,
  faBriefcase,
  faColumns,
  faArrowsAlt,
  faFilter,
  faClipboardList,
  faPlusSquare,
  faTasks,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

export const AI_GUIDE_STEPS: GuideStepConfig[] = [
  { icon: faRobot, titleId: "app.aiGeneration.guide.step1Title", bodyId: "app.aiGeneration.guide.step1Body" },
  { icon: faImages, titleId: "app.aiGeneration.guide.step2Title", bodyId: "app.aiGeneration.guide.step2Body" },
  { icon: faWandMagicSparkles, titleId: "app.aiGeneration.guide.step3Title", bodyId: "app.aiGeneration.guide.step3Body" },
  { icon: faShareSquare, titleId: "app.aiGeneration.guide.step4Title", bodyId: "app.aiGeneration.guide.step4Body" },
];

export const SOCIAL_POST_GUIDE_STEPS: GuideStepConfig[] = [
  { icon: faThumbsUp, titleId: "app.socialPost.guide.step1Title", bodyId: "app.socialPost.guide.step1Body" },
  { icon: faPenFancy, titleId: "app.socialPost.guide.step2Title", bodyId: "app.socialPost.guide.step2Body" },
  { icon: faCalendarAlt, titleId: "app.socialPost.guide.step3Title", bodyId: "app.socialPost.guide.step3Body" },
  { icon: faHistory, titleId: "app.socialPost.guide.step4Title", bodyId: "app.socialPost.guide.step4Body" },
];

export const BUSINESS_BOARD_GUIDE_STEPS: GuideStepConfig[] = [
  { icon: faBriefcase, titleId: "app.businessBoard.guide.step1Title", bodyId: "app.businessBoard.guide.step1Body" },
  { icon: faColumns, titleId: "app.businessBoard.guide.step2Title", bodyId: "app.businessBoard.guide.step2Body" },
  { icon: faArrowsAlt, titleId: "app.businessBoard.guide.step3Title", bodyId: "app.businessBoard.guide.step3Body" },
  { icon: faFilter, titleId: "app.businessBoard.guide.step4Title", bodyId: "app.businessBoard.guide.step4Body" },
];

export const ACTIVITY_BOARDS_GUIDE_STEPS: GuideStepConfig[] = [
  { icon: faClipboardList, titleId: "app.activity.guide.step1Title", bodyId: "app.activity.guide.step1Body" },
  { icon: faPlusSquare, titleId: "app.activity.guide.step2Title", bodyId: "app.activity.guide.step2Body" },
  { icon: faTasks, titleId: "app.activity.guide.step3Title", bodyId: "app.activity.guide.step3Body" },
  { icon: faUsers, titleId: "app.activity.guide.step4Title", bodyId: "app.activity.guide.step4Body" },
];
